export default class MyUploadAdapter {
    constructor( loader,baseUrl) {
        
        this.baseUrl= baseUrl;
        this.loader = loader;
    }

    upload() {
        return this.loader.file
            .then( file => new Promise( ( resolve, reject ) => {
                this._initRequest();
                this._initListeners( resolve, reject, file );
                this._sendRequest( file );
            } ) );
    }

    abort() {
        if ( this.xhr ) {
            this.xhr.abort();
        }
    }


     _initRequest() {
        const xhr = this.xhr = new XMLHttpRequest();
     
        
         xhr.open( 'POST', this.baseUrl , true );
         xhr.setRequestHeader("Authorization","Bearer " + localStorage.getItem("taksan_supplier_access_token"))
        xhr.responseType = 'json';
    }


    _initListeners( resolve, reject, file ) {
        const xhr = this.xhr;
        const loader = this.loader;
        const genericErrorText = `Couldn't upload file: ${ file.name }. مشکل در ارسال فایل`;

        xhr.addEventListener( 'error', () => reject( genericErrorText ) );
        xhr.addEventListener( 'abort', () => reject() );
        xhr.addEventListener( 'load', () => {
            const response = xhr.response;
            
            
            if ( !response || response.error ) {
                return reject( response && response.error ? response.error.message : genericErrorText );
            }

            
            resolve( {
                default: response.links[0].href
            } );
        } );

       
        if ( xhr.upload ) {
            xhr.upload.addEventListener( 'progress', evt => {
                if ( evt.lengthComputable ) {
                    loader.uploadTotal = evt.total;
                    loader.uploaded = evt.loaded;
                }
            } );
        }
    }

    _sendRequest( file ) {
      
        const data = new FormData();

        data.append( 'File', file );
        // data.append('FolderId',1);// این بخش از پنل ادمین کپ شده بود که از یک api دیگری استفاده میشد

       
        this.xhr.send( data );
    }
}
